<template>
  <div>
    <div class="row">
      <div class="form-group col-md-12">
        <label for="question" class="mb-1"><b><u class="section-title"><i class="fas fa-stream"></i>&nbsp;&nbsp;Preguntas&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u></b></label>
      </div>
      <div class="form-group col-md-4">
        <label for="question">Pregunta ó Código</label>
        <input v-model="filter.question" type="text" class="form-control input_sm" name="question" placeholder="Buscar Pregunta ó Código" @keyup.enter="getRecords(null)">
      </div>
      <div class="form-group col-md-3">
        <label for="course">Curso</label>
        <v-select v-model="filter.coursename" :options="courses" :disabled="courseSelectIsNotEmpty" class="my-custom-select" placeholder="Todos"></v-select>
      </div>
      <div class="form-group col-md-5">
        <label for="module">Módulo</label>
        <v-select v-model="filter.modulename" :options="modules" :disabled="moduleSelectIsNotEmpty" class="my-custom-select" placeholder="Todos"></v-select>
      </div>
      <div class="col-md-12">
        <button class="btn btn-sm btn-success btn-icon-split" title="Filtrar o buscar registro" @click="getRecords(null)"><i class="fas fa-filter"></i> Filtrar</button>
        <button class="btn btn-sm btn-danger btn-icon-split" title="Borrar filtro" @click="clearFilter()"><i class="fas fa-ban"></i></button>
      </div>
      <div class="col-12 text-right mt-1">
        <a :href="exportUrl(true)" class="btn btn-sm btn-secondary mt-1 mr-1" title="Descargar en Excel solo las preguntas sin respuestas o sin acierto marcado"><i class="fas fa-file-excel"></i> Incompletas</a>
        <a :href="exportUrl(false)" class="btn btn-sm btn-info mt-1 mr-1" title="Descargar en Excel las preguntas del filtro aplicado con sus respuestas"><i class="fas fa-file-excel"></i> Exportar</a>
        <button @click="create()" class="btn btn-sm btn-warning mt-1 mr-1" title="Agregar registro"><i class="fas fa-plus"></i> Nuevo</button>
        <hr>
      </div>
    </div>

    <b-overlay :show="loading" rounded="sm">
      <div class="table-responsive tableBg">
        <table class="table table-striped table-bordered zero-configuration">
          <thead>
            <tr>
              <th>#</th>
              <th>Acciones</th>
              <th>Módulo</th>
              <th>Código</th>
              <th>Pregunta</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(record, index) in records" :key="index">
              <td>{{ record.index }}</td>
              <td>
                <button class="btn btn-sm btn-danger btn-icon-split btn-xs" @click="destroy(record.id, record.code)" title="Eliminar">
                  <span class="icon text-white">
                    <i class="fas fa-trash icon_white"></i>
                  </span>
                </button>
                <button class="btn btn-sm btn-info btn-icon-split btn-xs" title="Editar" @click="showForm(record.id)">
                  <span class="icon text-white">
                    <i class="fas fa-edit icon_white"></i>
                  </span>
                </button>
                <button class="btn btn-sm btn-warning btn-icon-split btn-xs" @click="changeStatus(record.id, record.code)" title="Cambiar Estado">
                  <span class="icon text-white">
                      <i class="fas fa-flag icon_white"></i>
                  </span>
                </button>
                <button class="btn btn-sm btn-success btn-icon-split btn-xs" @click="showRecord(record)" title="Ver">
                  <span class="icon text-white">
                    <i class="fas fa-eye icon_white"></i>
                  </span>
                </button>
                <button class="btn btn-sm btn-light btn-icon-split btn-xs" @click="showAnswers(record.id, record.typeanswer_id, record.answer_number)" title="Respuestas">
                  <span class="icon text-white">
                    <i class="fas fa-list-ul icon_white"></i>
                  </span>
                </button>
              </td>
              <td>{{ record.modulename }}</td>
              <td>{{ record.code }}</td>
              <td v-html="record.question"></td>
              <td>
                <div :class="{ 'badge badge-success': record.status === 1, 'badge badge-danger': record.status !== 1 }">
                    {{ record.status === 1 ? 'Activo' : 'Inactivo' }}
                </div>
              </td>
            </tr>
            <tr v-if="total == 0">
              <td colspan="5">No hay registros</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>#</th>
              <th>Acciones</th>
              <th>Módulo</th>
              <th>Código</th>
              <th>Pregunta</th>
              <th>Estado</th>
            </tr>
          </tfoot>
        </table>
      </div>
      <!-- Contenedor de paginación -->
      <div class="pagination-container d-flex justify-content-end">
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item" v-for="link in links" :class="{'disabled': link.url == null, 'active': link.active}">
              <a class="page-link" @click="getRecords(link.url)" v-html="link.label"></a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="text-right">
        <span><i style="font-size: 14px; color: #7A7A7A">Cantidad de registros: {{total}}</i></span>
        <hr>
        <br>
      </div>
    </b-overlay>
    <modal-form v-if="showModalForm" :courseSelect="courseSelect" :moduleSelect="moduleSelect" :id="recordId" :showModal.sync="showModalForm" @getRecords="getRecords"></modal-form>
    <modal-status :code="recordCode" :id="recordId" :showModal.sync="showModalStatus" @getRecords="getRecords"></modal-status>
    <modal-destroy :code="recordCode" :id="recordId" :showModal.sync="showModalDestroy" @getRecords="getRecords"></modal-destroy>
    <modal-record :record="dataRecord" :showModal.sync="showModalRecord" @getRecords="getRecords"></modal-record>
    <modal-answers :question_id="recordId" :answer_number="answer_number" :typeanswer_id="recordTypeAnswerId" :showModal.sync="showModalAnswers" @getRecords="getRecords"></modal-answers>
  </div>
</template>

<script>
import ModalForm from './partials/ModalForm.vue'
import ModalStatus from './partials/ModalStatus.vue'
import ModalDestroy from './partials/ModalDestroy.vue'
import ModalRecord from './partials/ModalRecord.vue'
import ModalAnswers from './partials/ModalAnswers.vue'
import { BOverlay } from 'bootstrap-vue'
import vSelect from 'vue-select';


export default {
  components: {ModalForm, BOverlay, ModalStatus, ModalDestroy, ModalRecord, ModalAnswers, vSelect},
  data() {
    return {
      records: [],
      courses: [],
      modules: [],
      courseId: null,
      courseSelect: 0,
      moduleSelect: 0,
      loading: false,
      filter: {
        question: '',
        coursename: null,
        modulename: null,
      },
      appliedFilter: {}, // filtro con el que se cargó la tabla; lo usa la exportación
      links: {},
      total: 0,
      recordId: null,
      recordTypeAnswerId: null,
      answer_number: null,
      recordCode: null,
      dataRecord: [],
      showModalForm: false,
      showModalStatus: false,
      showModalDestroy: false,
      showModalRecord: false,
      showModalAnswers: false,
      form: {
        coursename: ''
      },
      courseSelectIsNotEmpty: false,
      moduleSelectIsNotEmpty: false,
    }
  },
  created() {
    this.getRecords(null);
    this.getCourses();
  },
  watch: {
    'filter.coursename'(course) {
      this.filter.modulename = null;
      this.modules = [];
      this.courseSelect = 0;
      this.moduleSelect = 0;

      if (course) {
        this.courseSelect = course;

        axios.get(`/administration/courses/questions/getModules/${course.value}`)
          .then(response => {
            this.modules = response.data.data;
          })
          .catch(error => {
            console.error("Error al obtener módulos:", error);
          });
      }
    },
    'filter.modulename'(module) {
      if(module){
        this.moduleSelect = module;
      }else{
        this.moduleSelect = 0;
      }
    }
  },
  methods:{
    typeInput(){
      // if(this.filter.question){
      //   this.courseSelectIsNotEmpty=true;
      //   this.moduleSelectIsNotEmpty=true;
      //   this.filter.coursename = '';
      //   this.filter.modulename = '';
      // }else{
      //   this.courseSelectIsNotEmpty=false;
      //   this.moduleSelectIsNotEmpty=false;
      // }
    },
    /**
     * URL de descarga en Excel respetando el filtro de curso/módulo activo.
     * onlyIssues = solo preguntas sin respuestas o sin acierto marcado.
     */
    exportUrl(onlyIssues) {
      const filter = this.appliedFilter;
      const params = new URLSearchParams();
      if (filter.coursename) params.append('course_id', filter.coursename.value);
      if (filter.modulename) params.append('module_id', filter.modulename.value);
      if (!onlyIssues) {
        // La exportación completa también respeta el texto buscado
        if (filter.question) params.append('question', filter.question);
        params.append('all', '1');
      }
      const query = params.toString();
      return '/administration/courses/questions/export' + (query ? '?' + query : '');
    },
    clearFilter(){
      this.filter= {
        question: '',
        coursename: null,
        modulename: null,
      },
      this.getRecords(null);
      this.courseSelectIsNotEmpty=false;
      this.moduleSelectIsNotEmpty=false;
    },
    getRecords(url = null) {
      this.loading = true
      let page = 1
      if(url) {
        let param = new URL(url);
        page = param.searchParams.get("page");
      }
      this.appliedFilter = Object.assign({}, this.filter);

      axios.get(`/administration/courses/questions/records?page=${page}`, {params: this.filter})
        .then(response => {
          this.records = response.data.data.data;
          this.links = response.data.data.links;
          this.total = response.data.data.total;
        })
        .catch((error)=>{
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getCourses() {
      axios.get(`/administration/courses/questions/getCourses`)
        .then(response => {
          this.courses = response.data.data
        })
    },
    // getModules(module_id) {
    //   console.log(module_id);
    // // axios.get(`/administration/courses/questions/getModules/${course_id}`)
    // //   .then(response => {
    // //     if (this.coursesSelect === course_id) {
    // //       this.modules = response.data.data;
    // //       console.log("si");
    // //     } else {
    // //       this.form.modulename = null;
    // //       this.modules = response.data.data;
    // //       this.coursesSelect = course_id;  // Actualizar coursesSelect
    // //       console.log("no");
    // //     }
    // //   })
    // //   .catch(error => {
    // //       console.error("Error al obtener módulos:", error);
    // //   });
    // },
    showForm(id) {
      this.recordId = id
      this.showModalForm = true
    },
    create() {
      this.recordId = null
      this.showModalForm = true
    },
    changeStatus(id, code) {
      this.recordId = id
      this.recordCode = code
      this.showModalStatus = true
    },
    destroy(id, code) {
      this.recordId = id
      this.recordCode = code
      this.showModalDestroy = true
    },
    showRecord(record) {
      // this.recordId = id
      this.dataRecord = record
      this.showModalRecord = true
      // console.log(this.dataRecord)
    },
    showAnswers(question_id, typeanswer_id, answer_number) {
      this.recordId = question_id
      this.recordTypeAnswerId = typeanswer_id
      this.answer_number = answer_number
      this.showModalAnswers = true
      // console.log(this.answer_number)
    },
  }
}
</script>

<style scoped>
.pagination-container {
  margin-top: 10px !important; /* Ajusta según sea necesario */
}
</style>